






























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { HandleDirective } from 'vue-slicksort';
import { Slide, SlideAnswers, QuizSlideResult } from 'src/assets/AttendeeItemData'
import MarkdownViewerCrdt from 'components/MarkdownViewerCrdt.vue'
import ButtonCheck from 'components/presenter/item/topic/viewer/ButtonCheck.vue'
import SlickList from 'components/SlickList.vue'
import SlickListItem from 'components/SlickListItem.vue'

@Component({
  components: {
    MarkdownViewerCrdt,
    ButtonCheck,
    SlickList,
    SlickListItem
  },
  directives: {
    handle: HandleDirective
  }
})
export default class ItemTopicViewerOrder extends Vue {
  response: string[] = []
  transition = 'answers'

  @Prop({ default: false })
  readonly feedbackButtonShow!: boolean

  @Prop({ default: false })
  readonly feedbackButtonShowAlways!: boolean

  @Prop({ default: false })
  readonly feedbackButtonOn!: boolean

  @Prop()
  readonly slide!: Json

  @Prop()
  readonly seed!: string | undefined

  @Prop()
  readonly result!: QuizSlideResult | undefined

  @Prop({ default: () => { return {} } })
  readonly meta!: Json

  @Prop({ default: false })
  readonly readonly!: boolean

  @Prop()
  readonly value!: string[] | undefined

  @Watch('value', { immediate: true })
  update (value: string[] | undefined) {
    const response: string[] = value ? [...value] : []
    this.response = response.filter(id => this.answers.find((answer: Json) => answer.id === id && !answer.deleted))
  }

  get text () {
    return this.slide?.text?.getText()
  }

  get answers () {
    const sorted = new SlideAnswers(this.slide as Slide, this.seed)
    return [...sorted.answers]
  }

  get answersInOrder () {
    const selected = this.answers.filter((answer: Json) => (answer.order = this.response.indexOf(answer.id) + 1) !== 0)
    const shuffled = this.answers.filter((answer: Json) => (answer.order = this.response.indexOf(answer.id) + 1) === 0)
    selected.sort((a: Json, b: Json) => a.order > b.order ? 1 : -1)
    return [...selected, ...shuffled]
  }

  get size () {
    return this.$q.screen.lt.md ? 'md' : 'lg'
  }

  get canRespond () {
    return !(this.readonly || this.feedbackButtonOn)
  }

  respond (id: string) {
    if (this.canRespond) {
      const index = this.response.indexOf(id)
      if (index === -1) {
        this.response.push(id)
      } else {
        this.response.splice(index, 1)
      }
      this.$emit('input', this.response.length ? this.response : undefined)
    }
  }

  respondSortEnd ({ newIndex, oldIndex }: { newIndex: number, oldIndex: number }) {
    if (this.canRespond && newIndex !== oldIndex) {
      this.transition = 'skip'
      const out = this.response.splice(oldIndex, 1)
      this.response.splice(newIndex, 0, out[0])
      this.$emit('input', this.response)
      this.$nextTick(() => { this.transition = 'answers' })
    }
  }

  respondInput (answers: Json[]) {
    // if (this.canRespond) {
    //   this.transition = 'skip'
    //   this.response = answers.filter(a => a.order).map(a => a.id)
    //   this.$emit('input', this.response)
    //   this.$nextTick(() => { this.transition = 'answers' })
    // }
  }
}
